define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext) {
    "use strict";
    var CustomerPlansReport = /** @class */ (function () {
        function CustomerPlansReport() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,InternalReports.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
        }
        CustomerPlansReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customers Plans");
            tools.ajaxGet({
                url: "/Reports/GetCustomerPlansReportLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookups = data.Data.lookupLists;
                        self.initGrid(self.lookups.GridStructures.CustomerPlansReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerPlansReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCustomerPlansReportKendo";
            var columns = gridStructure.columns;
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCustomerPlansData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "AccountNumber", dir: "asc" }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#customerplansreport-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "CustomerCallPlan",
                    title: "Customer Plans Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
        };
        CustomerPlansReport.prototype.clearFilter = function () {
            var self = this;
        };
        CustomerPlansReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return CustomerPlansReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CustomerPlansReport")) {
            log.log("Initialize CustomerPlansReport list");
            $(function () {
                (new CustomerPlansReport()).init();
            });
        }
    }, 0);
    return CustomerPlansReport;
});
//# sourceMappingURL=customerPlansReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/customerPlansReport.js
// module id = 259
// module chunks = 2